export enum AnticheatDemoCheckStatus {
  CHECKED = 'checked',
  NOT_A_DEMO = 'not_a_demo',
  NOT_STARTED = 'not_started',
  NOT_AVAILABLE = 'not_available',
  UNAVAILABLE = 'unavailable',
}
